import React from 'react';
import { useSelector } from 'react-redux';
import { CustomizedSwitch, ToolInfo, LocalDateRow } from 'components';
import { useModal } from 'utils';
import { SignatureReminder } from '../signatureReminder';
import {reminderTargetEnum} from "../constants";

export const RequireInfoBox = ({ styles }) => {
    const { item } = useSelector((state) => ({
        item: state.appointment.appointmentById,
    }));
    const { open } = useModal();

    return (
        <div className="signature-drawwer-box" style={styles}>
            <div>
                <div className="flex-align-center" style={{ gap: 8, opacity: 0.7 }}>
                    <ToolInfo text={'Require Client/Guardian signature to render this appointment.'} />
                    <p>Client/Guardian Sign. Req.</p>
                    <CustomizedSwitch disabled={true} checked={item?.requireSignature} />
                </div>

                <div className="flex-align-center" style={{ gap: 4 }}>
                    {item?.signatureRemindedDate && (
                        <span className="signature-reminded-date">
                            <span style={{ marginRight: 4 }}>Remind</span>
                            <LocalDateRow date={item?.signatureRemindedDate} />
                        </span>
                    )}

                    <button
                        className="send-reminder-btn"
                        onClick={() =>
                            open(
                                <SignatureReminder
                                    selectedList={[item?.id]}
                                    selectedFullList={[item]}
                                    afterSuccess={() => {}}
                                    single={item?.id}
                                    reminderType={reminderTargetEnum.CLIENT}
                                />
                            )
                        }>
                        {item?.signatureRemindedDate ? 'Send Again' : 'Send Reminder'}
                    </button>
                </div>
            </div>

            <div>
            <div className="flex-align-center" style={{ gap: 8, opacity: 0.7 }}>
                <ToolInfo text={'Require Provider signature to render this appointment.'} />
                <p>Provider Sign. Req.</p>
                <CustomizedSwitch disabled={true} checked={item?.requireProviderSignature} />
            </div>
                <div className="flex-align-center" style={{ gap: 4 }}>
                    {item?.providerSignatureRemindedDate && (
                        <span className="signature-reminded-date">
                            <span style={{ marginRight: 4 }}>Remind</span>
                            <LocalDateRow date={item?.providerSignatureRemindedDate} />
                        </span>
                    )}

                    <button
                        className="send-reminder-btn"
                        onClick={() =>
                            open(
                                <SignatureReminder
                                    selectedList={[item?.id]}
                                    selectedFullList={[item]}
                                    afterSuccess={() => {}}
                                    single={item?.id}
                                    reminderType={reminderTargetEnum.PROVIDER}
                                />
                            )
                        }>
                        {item?.providerSignatureRemindedDate ? 'Send Again' : 'Send Reminder'}
                    </button>
                </div>
            </div>


            <div className="flex-align-center" style={{ gap: 8, opacity: 0.7 }}>
                <ToolInfo text={'Require notes to render this appointment.'} />
                <p>Notes Req.</p>
                <CustomizedSwitch disabled={true} checked={item?.requireNote} />
            </div>
        </div>
    );
};
